/**
 * Names on certificates use English letters for now: the site is English
 * only, and certificates use the PDF built-in fonts. Revisit when other
 * languages arrive.
 */
export const DISPLAY_NAME_PATTERN = "[A-Za-z][A-Za-z .'’\\-]*";
export const DISPLAY_NAME_REGEX = new RegExp(`^${DISPLAY_NAME_PATTERN}$`);
export const DISPLAY_NAME_HINT =
  'Use English letters (A–Z), spaces, apostrophes, hyphens and periods only';
